import { render, staticRenderFns } from "./hrOptionsTemp.vue?vue&type=template&id=08a13b28&scoped=true&"
import script from "./hrOptionsTemp.vue?vue&type=script&lang=ts&"
export * from "./hrOptionsTemp.vue?vue&type=script&lang=ts&"
import style0 from "./hrOptionsTemp.vue?vue&type=style&index=0&id=08a13b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a13b28",
  null
  
)

export default component.exports